// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"L1-z"};